import gql from "graphql-tag";

export const FOLDERS = gql`
  query folders($where: FoldersWhereInput) {
    folders(where: $where) {
      data {
        folderNum
        creationDate
        interventionType
        statusCode
        statusDesc
        statusComment
        statusColor
        productPhoto
        productCode
        productBrand
        productDesc
        productRef
        receiptNo
        warrantyDesc
        indicatorFolderMsg
        receiptLinekey
        planningDay {
          date
          intervals {
            start
            end
          }
        }
        extra {
          workflow {
            pageChunk
            processCode
            actions {
              pageChunk
              code
              description
            }
            documentation {
              description
              url
              docType
            }
          }
        }
      }
      count
    }
  }
`;

export const FOLDER = gql`
  query folder($where: FolderWhereInput) {
    folder(where: $where) {
      folderNum
      creationDate
      interventionType
      statusCode
      statusDesc
      statusComment
      statusColor
      productPhoto
      productCode
      productBrand
      productDesc
      productRef
      warrantyDesc
      indicatorFolderMsg
      planningDay {
        date
        intervals {
          start
          end
        }
      }
      extra {
        workflow {
          pageChunk
          processCode
          actions {
            pageChunk
            code
            description
          }
          documentation {
            description
            url
            docType
          }
        }
      }
    }
  }
`;

export const FOLDER_STATUS = gql`
  query folderStatus($where: FolderWhereInput) {
    folderStatus(where: $where) {
      statusCode
      statusDesc
      processCode
      processDesc
      documentation {
        description
        url
        docType
      }
      planningDay {
        date
        intervals {
          start
          end
        }
      }
      fieldsItemList {
        desc
        value
      }
    }
  }
`;

export const FOLDER_RULES = gql`
  query folderRules($where: FolderRulesWhereInput) {
    folderRules(where: $where) {
      data {
        interventionTypes
        faultTypes
        masks
        warrantyTypes
        forms
      }
      count
    }
  }
`;
